import { Component, inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericIdbaComponent } from './generic-idba.component';
import { GlobalVariablesService } from '../../services/global-variables.service';
import { TrataExcessaoService } from '../../services/trata-excessao.service';
import { takeUntil } from 'rxjs';
@Component({
  standalone: false,
  selector: 'app-generic-idba-filter-component',
  template: ` <p>abstract-idba-filter-component works!</p> `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [],
})
export class GenericIdbaFilterComponent extends GenericIdbaComponent {

  public dialogRef: MatDialogRef<this>;
  public dialogData = {};
  public declare form: UntypedFormGroup;
  public filterObject: any;
  public filterValidity: number = 60; // Validade do filtro em minutos
  public filterKey: string = '';

  public globalVariables = inject(GlobalVariablesService);
  public injector = inject(Injector);

  constructor() {
    super();
    if (this.globalVariables?.telaAtiva) {
      this.programa = this.globalVariables.telaAtiva.replace(" ", "_");
    }

  }

  override ngOnInit(): void {
    this.consultaPermissaoAcesso();
    this.dialogRef = this.injector.get(MatDialogRef);
    this.dialogData = this.injector.get(MAT_DIALOG_DATA, null);

    const filterKey = this.filterKey == '' ? `${this.programa}Filter` : this.filterKey;
    const storedFilter = sessionStorage.getItem(filterKey);
    const dialogFilter = this.dialogData && typeof this.dialogData === 'object' && Object.keys(this.dialogData).length > 0
      ? { ...this.dialogData }
      : null;

    this.filterObject = dialogFilter
      ?? (storedFilter ? JSON.parse(storedFilter) : null)
      ?? this.initializeFilter()
      ?? {};

    const validadeFiltro = this.filterObject['validadeFiltro'];
    if (validadeFiltro) {
      const validade = new Date(validadeFiltro).getTime();
      if (!Number.isNaN(validade) && validade < Date.now()) {
        this.filterObject = this.initializeFilter() ?? {};
      }
    }
    this.createForm();
    this.populateForm();
  }

  public validateForm() {
    this.form.markAllAsTouched();
    return this.form.valid;
  }

  public initializeFilter() {
    return {};
  }

  public closeModal() {
    if (this.validateForm()) {
      let formData = this.form.getRawValue();
      formData = this.beforeSaveFilter(formData);
      const agora = new Date();
      formData['validadeFiltro'] = agora.setMinutes(agora.getMinutes() + this.filterValidity);
      const filterKey = this.filterKey == '' ? `${this.programa}Filter` : this.filterKey;
      sessionStorage.setItem(filterKey, JSON.stringify(formData));

      Object.keys(formData).forEach(key => {
        if (formData[key]?.id) {
          formData[key] = formData[key].id;
        }
      });

      this?.dialogRef?.close(formData);
    }
  }

  public beforeSaveFilter(formData): any {
    return formData;
  }

  public createForm() {
    throw new Error("Implementar função 'createForm' com override na classe principal!");
  }

  public populateForm() {
    if (this.filterObject && Object.keys(this.filterObject).length !== 0) {
      this.form.patchValue(this.filterObject);
    }
  }

  override consultaPermissaoAcesso() {
    this.acessoService
      .pesquisaPermissaoAcesso()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.acesso = response.body.data;
          if (this.acesso?.funcoes) {
            this.acesso.funcoes.forEach(element => {
              this.funcoes[element.codigo] = element.ativo;
            });
          }
        }
      });
  }

}
